import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadLineitems, loadLineitemsByProjectId, reset, setLimitOffsetSort, loadUsers, updateAssignedUser } from '../actions'
import Lineitems from '../components/Lineitems'

const convertLineItems = (lineitems, projectLineitems) => {
    const convertedLineItems = [];

    lineitems.forEach((l, i) => {
        const list = projectLineitems[l.extProjectId] || []
        // const litems = list
        const litems = list.filter(le => le.extLineItemId !== l.extLineItemId)
        const lineitem = {
            ...l,
            key: i,
            lineitems: litems
        }
        convertedLineItems.push(lineitem);
    })
    return convertedLineItems;
}

function mapStateToProps(state) {
    const { lineitems, filter } = state
    return {
        ...lineitems,
        lineitems: convertLineItems(lineitems.lineitems, lineitems.projectLineitems),
        filter
    }
}

function mapDispatchToProps(dispatch) {
    const actions = {
        loadLineitems,
        loadLineitemsByProjectId,
        reset,
        setLimitOffsetSort,
        loadUsers,
        updateAssignedUser
    }

    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Lineitems)
